import React, { useState, useEffect, useRef } from "react"
import { Modal }                              from "@shared/modal"
import Checkbox                               from "@shared/checkbox/checkbox"
import Sortable                               from "sortablejs"

const TableColumnModal = ({
  id,
  columns         = [],
  selectedColumns = [],
  isOpen,
  setIsOpen,
  onConfirm,
  title,
  confirmText,
  tableTitle = '',
}) => {
  const [orderedColumns, setOrderedColumns] = useState(columns)
  const [selected,       setSelected]       = useState([])
  const [name,           setName]           = useState(tableTitle)
  const containerRef                        = useRef(null)

  useEffect(() => {
    if (isOpen) {
      const unselected = columns.filter(col => !selectedColumns.includes(col))
      setOrderedColumns([...selectedColumns, ...unselected])
      setSelected(selectedColumns)
      setName(tableTitle)
    }
  }, [isOpen])

  useEffect(() => {
    if (!isOpen || !containerRef.current) return

    const sortable = Sortable.create(containerRef.current, {
      animation: 150,
      handle:    ".table-drag-handle",
      onEnd:     evt => {
        if (evt.oldIndex === evt.newIndex) return

        setOrderedColumns(prev => {
          const updated      = [...prev]
          const [moved]      = updated.splice(evt.oldIndex, 1)
          updated.splice(evt.newIndex, 0, moved)
          return updated
        })
      },
    })

    return () => sortable.destroy()
  }, [isOpen])

  const toggleColumn = col => {
    setSelected(prev =>
      prev.includes(col) ? prev.filter(c => c !== col) : [...prev, col]
    )
  }

  const handleConfirm = () => {
    const selectedInOrder = orderedColumns.filter(col => selected.includes(col))
    onConfirm(selectedInOrder, name)
  }

  return (
    <Modal
      id          = {id}
      isOpen      = {isOpen}
      setIsOpen   = {setIsOpen}
      title       = {title}
      size        = 'large'
      onConfirm   = {handleConfirm}
      disabled    = {selected.length === 0 || !name}
      confirmText = {confirmText}
    >
      <div className = "form-group">
        <label htmlFor = "table-title">
          {I18n.t("export.table_title")}
        </label>

        <input
          type        = "text"
          id          = "table-title"
          className   = "form-control"
          value       = {name}
          onChange    = {e => setName(e.target.value)}
          placeholder = {I18n.t("export.table_title_placeholder")}
        />
      </div>

      <h5 className = "py-3">{I18n.t("export.table_columns_hint")}</h5>

      <div ref = {containerRef}>
        {orderedColumns.map(col => (
          <div
            key       = {col}
            className = "form-group d-flex a-i-center"
          >
            <i className = "fa fa-bars table-drag-handle mr-3 text-muted cursor-pointer" />
            <Checkbox
              id        = {`col-${col}`}
              checked   = {selected.includes(col)}
              onChange  = {() => toggleColumn(col)}
              label     = {col}
              className = "form-group mb-0"
            />
          </div>
        ))}
      </div>
    </Modal>
  )
}

export default TableColumnModal
